import {
  LIST_TRACES_ROUTE,
  LIST_TRACES_LIGHT_ROUTE,
  LIST_BRANCHES_ROUTE,
  GET_BRANCH_ROUTE,
  GET_TRACE_ROUTE,
  GET_TRACE_LIGHT_ROUTE,
  GET_SPAN_ROUTE,
  GET_TRACE_TRAJECTORY_ROUTE,
  SCORE_TRACES_ROUTE,
  LIST_SCORES_BY_SPAN_ROUTE,
} from '../../handlers/observability';
import {
  LIST_METRICS,
  LIST_LOGS,
  LIST_SCORES,
  CREATE_SCORE,
  GET_SCORE,
  GET_SCORE_AGGREGATE,
  GET_SCORE_BREAKDOWN,
  GET_SCORE_TIME_SERIES,
  GET_SCORE_PERCENTILES,
  LIST_FEEDBACK,
  CREATE_FEEDBACK,
  GET_FEEDBACK_AGGREGATE,
  GET_FEEDBACK_BREAKDOWN,
  GET_FEEDBACK_TIME_SERIES,
  GET_FEEDBACK_PERCENTILES,
  GET_METRIC_AGGREGATE,
  GET_METRIC_BREAKDOWN,
  GET_METRIC_TIME_SERIES,
  GET_METRIC_PERCENTILES,
  GET_METRIC_NAMES,
  GET_METRIC_LABEL_KEYS,
  GET_METRIC_LABEL_VALUES,
  GET_ENTITY_TYPES,
  GET_ENTITY_NAMES,
  GET_SERVICE_NAMES,
  GET_ENVIRONMENTS,
  GET_TAGS,
} from '../../handlers/observability-new-endpoints';

export const OBSERVABILITY_ROUTES = [
  // Legacy
  LIST_TRACES_ROUTE,
  LIST_TRACES_LIGHT_ROUTE,
  LIST_BRANCHES_ROUTE,
  GET_BRANCH_ROUTE,
  GET_TRACE_ROUTE,
  GET_TRACE_LIGHT_ROUTE,
  GET_SPAN_ROUTE,
  GET_TRACE_TRAJECTORY_ROUTE,
  SCORE_TRACES_ROUTE,
  LIST_SCORES_BY_SPAN_ROUTE,
  // New observability routes
  LIST_METRICS,
  LIST_LOGS,
  LIST_SCORES,
  CREATE_SCORE,
  GET_SCORE,
  GET_SCORE_AGGREGATE,
  GET_SCORE_BREAKDOWN,
  GET_SCORE_TIME_SERIES,
  GET_SCORE_PERCENTILES,
  LIST_FEEDBACK,
  CREATE_FEEDBACK,
  GET_FEEDBACK_AGGREGATE,
  GET_FEEDBACK_BREAKDOWN,
  GET_FEEDBACK_TIME_SERIES,
  GET_FEEDBACK_PERCENTILES,
  GET_METRIC_AGGREGATE,
  GET_METRIC_BREAKDOWN,
  GET_METRIC_TIME_SERIES,
  GET_METRIC_PERCENTILES,
  GET_METRIC_NAMES,
  GET_METRIC_LABEL_KEYS,
  GET_METRIC_LABEL_VALUES,
  GET_ENTITY_TYPES,
  GET_ENTITY_NAMES,
  GET_SERVICE_NAMES,
  GET_ENVIRONMENTS,
  GET_TAGS,
] as const;
